function helperStringUpperCase (str) {
  return str.toUpperCase()
}

module.exports = helperStringUpperCase



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/string/helperStringUpperCase.js
// module id = 1937
// module chunks = 106